import React, { useEffect } from 'react';
import styles from './scenario-studio.module.css';

interface AssetPreviewModalProps {
  src: string;
  path: string;
  onClose: () => void;
}

export const AssetPreviewModal: React.FC<AssetPreviewModalProps> = ({ src, path, onClose }) => {
  const fileName = path.split(/[/\\]/).pop() ?? 'asset';

  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [onClose]);

  const handleDownload = () => {
    void (async () => {
      const response = await fetch(src);
      const blob = await response.blob();
      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = fileName;
      link.click();
      URL.revokeObjectURL(url);
    })();
  };

  return (
    <div className={styles.modalOverlay} onClick={onClose}>
      <div
        className={`${styles.modal} ${styles.assetPreviewModal}`}
        onClick={(e) => e.stopPropagation()}
      >
        <header className={styles.modalHeader}>
          <h3 className={styles.assetPreviewTitle}>{path}</h3>
          <button type="button" className={styles.iconBtn} onClick={onClose}>
            ×
          </button>
        </header>
        <div className={styles.assetPreviewBody}>
          <img className={styles.assetPreviewImg} src={src} alt={path} />
        </div>
        <footer className={styles.modalFooter}>
          <button type="button" className={styles.btnSecondary} onClick={handleDownload}>
            Télécharger
          </button>
        </footer>
      </div>
    </div>
  );
};
